import { SpeckleMaterial } from "../../../types/Views/MappingWizard/SpeckleMaterial";
import { v4 as uuidv4 } from "uuid";

export const initializeBranchMaterials = (materials: Array<SpeckleMaterial>, byType: boolean) => {
  materials.forEach((speckleGroup) => {
    speckleGroup.validationErrors = [];
    speckleGroup.forceUpdater = uuidv4();
    speckleGroup.children?.forEach((speckleChild) => {
      //Set new fields on SpeckleMaterials
      speckleChild.validationErrors = [];
      speckleChild.newLifeTime = 0;
      speckleChild.totalDeclaredUnits.forEach((declaredUnit) => {
        declaredUnit.newValue = null;
        declaredUnit.wasChanged = false;
      });
    });

    if (!byType) {
      //If !byType then sort Material > Category > Type
      speckleGroup.children?.sort((a, b) =>
        a.category == null
          ? -1
          : b.category == null
            ? -1
            : a.category.toLowerCase() < b.category.toLowerCase()
              ? -1
              : a.category.toLowerCase() > b.category.toLowerCase()
                ? 1
                : (a.identifier ?? "").toLowerCase() < (b.identifier ?? "").toLowerCase()
                  ? -1
                  : (a.identifier ?? "").toLowerCase() > (b.identifier ?? "").toLowerCase()
                    ? 1
                    : 0
      );
    } else {
      //Else sort Category > Type > Material
      speckleGroup.children?.sort((a, b) =>
        a.identifier == null
          ? -1
          : b.identifier == null
            ? -1
            : a.identifier.toLowerCase() < b.identifier.toLowerCase()
              ? -1
              : a.identifier.toLowerCase() > b.identifier.toLowerCase()
                ? 1
                : 0
      );
    }
  });

  if (!byType) {
    //If !byType then sort Material > Category > Type
    materials.sort((a, b) =>
      a.identifier == null
        ? -1
        : b.identifier == null
          ? -1
          : a.identifier.toLowerCase() < b.identifier.toLowerCase()
            ? -1
            : a.identifier.toLowerCase() > b.identifier.toLowerCase()
              ? 1
              : 0
    );
  } else {
    //Else sort Category > Type > Material
    materials.sort((a, b) =>
      a.category == null
        ? -1
        : b.category == null
          ? -1
          : a.category.toLowerCase() < b.category.toLowerCase()
            ? -1
            : a.category.toLowerCase() > b.category.toLowerCase()
              ? 1
              : (a.identifier ?? "").toLowerCase() < (b.identifier ?? "").toLowerCase()
                ? -1
                : (a.identifier ?? "").toLowerCase() > (b.identifier ?? "").toLowerCase()
                  ? 1
                  : 0
    );
  }

  return materials;
};
